const ESV_STORAGE_KEY = "user_details";

/**
 * Get user info stored in session storage.
 * @returns {Object} user info object if found, null otherwise
 */
export const getUserCredentials = () => {
  const userInfoAsString = sessionStorage.getItem(ESV_STORAGE_KEY);

  if (!userInfoAsString) {
    return null;
  }

  try {
    const userInfo = JSON.parse(userInfoAsString);
    return userInfo;
  } catch (e) {
    // Invalid JSON, return null
    return null;
  }
};

/**
 * Store user info in session storage.
 * @param {String} _storageType (always uses sessionStorage)
 * @param {Object} data user info
 * @param {Object} appContext app-level state
 */
export const setUserCredentials = (_storageType, data, appContext) => {
  /** Update user info in app-level state */
  if (appContext && appContext.setUserTitle) {
    const { setUserTitle } = appContext;
    setUserTitle(data.user_title);
  }
  sessionStorage.setItem(ESV_STORAGE_KEY, JSON.stringify(data));
};

/**
 * Check if user is logged in (checks session storage)
 * @returns {Boolean} true if user is logged in, false if not
 */
export const isUser = () => {
  const user_details = getUserCredentials();
  return !!(user_details && (user_details.firebase_id_token || user_details.user_email || user_details.uid));
};

/**
 * Returns fields to be added to every api payload
 * @returns {Object} returns { user_payload, company_name, company_domain } if user is not null
 */
export const getMandatoryUserData = () => {
  const user = getUserCredentials();
  return user === null ? {} : { user_payload: user.user_payload, company_name: user.company_name, company_domain: user.company_domain };
};

/**
 * Sign out user by clearing storage
 * Clears sessionStorage
 * @param {Object} history react-router history object
 * @param {Object} appContext app-level state
 */
export const signOut = (history, appContext) => {
  sessionStorage.clear();
  /** Clear user title in state */
  if (appContext && appContext.setUserTitle) {
    const { setUserTitle } = appContext;
    setUserTitle("");
  }

  if (history) {
    history.replace("/login");
  } else {
    // Fallback to window.location if no history provided
    window.location.pathname = "/login";
  }
};
